import { render, staticRenderFns } from "./InstructionsDetailedProduceStep1.vue?vue&type=template&id=3efab2d8&"
import script from "./InstructionsDetailedProduceStep1.vue?vue&type=script&lang=js&"
export * from "./InstructionsDetailedProduceStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports